import { useMutation, useQuery } from "@apollo/client";
import { useContext, useMemo } from "react";
import { GlobalConfigContext } from "../context/GlobalConfigContext";
import saveTag from "../graphql/mutations/saveTag";
import { listStoreGroups } from "../graphql/queries/listStoreGroups";

export const useStoreGroups = () => {
  const { tagsData, refetchProgramConfig } = useContext(GlobalConfigContext);
  const { data, loading, error, refetch } = useQuery(listStoreGroups, {
    variables: { field: "category", type: "OUTLET" },
    fetchPolicy: "cache-and-network",
    notifyOnNetworkStatusChange: true,
  });
  const [saveTagMutation, { loading: savingTag }] = useMutation(saveTag);

  const storeGroups = useMemo(() => {
    const queryGroups = data?.getDistinctKeywordGroupsField || [];
    const tagGroups = tagsData?.storeGroups || [];
    const merged = [...new Set([...tagGroups, ...queryGroups])];
    return merged
      .sort((first, second) =>
        first.localeCompare(second, undefined, { sensitivity: "base" })
      )
      .map((storeGroup) => ({
        id: storeGroup,
        displayText: storeGroup,
      }));
  }, [data, tagsData]);

  const createStoreGroup = async (name) => {
    const result = await saveTagMutation({
      variables: { tag: { type: "STORE_GROUPS", value: name } },
    });
    refetchProgramConfig();
    refetch();
    return result;
  };

  return {
    storeGroups,
    loading,
    error,
    refetch,
    savingTag,
    createStoreGroup,
    refetchProgramConfig,
  };
};
